import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_NO: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astrologi',
  components_header_media_multi_content_2: 'Meditasjon',
  components_header_media_multi_content_3: 'Kjærlighet',
  components_header_text1: 'Guider',
  components_header_text2: 'Blogg',
  hero_text: 'Finn klarhet, balanse og forbindelse.',
  hero_button_text: 'Start reisen din',
  components_ressources_subheader_text: 'Tips og inspirasjon',
  components_ressources_span_text: 'Den kombinerer personlig astrologisk innsikt, beroligende meditasjonspraksis og gjennomtenkt kjærlighetsveiledning for å støtte selvoppdagelse, emosjonell balanse og dypere forbindelse.',
  components_ressources_card_1_title: 'Meditasjonstips',
  components_ressources_card_1_text: 'Hurtigguide for bedre ro, pust og fokus.',
  components_ressources_card_2_title: 'Kjærlighetsveiledning',
  components_ressources_card_2_text: 'Enkle tips for å bygge sterkere forbindelser og emosjonell balanse.',
  components_ressources_link: 'Oppdag mer',
  components_notes_and_google_title_1: 'Finn klarhet',
  components_notes_and_google_title_2: 'Indre ro',
  components_notes_and_google_title_3: 'Hjerteforbindelse',
  media_content_section_multi_1_subheader_text: 'Podkasten vår',
  media_content_section_multi_2_subheader_text: 'Våre meditasjoner',
  media_content_section_multi_3_subheader_text: 'Ærlig snakk om kosmisk romantikk',
  page_media_content_menu_antistress: 'Antistress',
  page_media_content_menu_mindfulness: 'Mindfulness',
  page_media_content_menu_energyboost: 'Energiboost',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Fundamenter',
  page_media_content_menu_spirituality: 'Spiritualitet',
  page_media_content_menu_tarot: 'Tarotkort',
  page_media_content_menu_psychology: 'Psykologi',
  page_media_content_menu_trends: 'Trender',
  page_media_content_menu_compatibility: 'Kompatibilitet',
  page_media_content_menu_love: 'Kjærlighet',
  text2_section_title: 'BLOGG',
  text2_section_subheader_text: 'Artikler og innsikt',
  text2_section_button_more: 'Last inn mer',
  components_text1_section_title: 'GUIDER',
  components_text1_subheader_text: 'Kosmisk kunnskap for daglig innretting',
  components_text1_span_text: 'Innrett deg etter universets rytmer: utforsk en kuratert samling av dyptgående astrologiske og meditative guider designet for å vekke indre klarhet, fordype selvinnsikt og støtte din reise mot sjelfull, himmelsk vekst.',
  components_text1_card_1_title: 'Åpen for stillheten',
  components_text1_card_1_text: 'Start reisen din med grunnleggende meditasjons- og astrologiguider – ideelt for søkere som er tiltrukket av indre stillhet, kosmiske mønstre og personlig innsikt.',
  components_text1_card_3_title: 'Sinn-kropp-kobling',
  components_text1_card_3_text: 'Avdekk de dypere lagene i din indre verden. Disse guidene beveger seg utover overflaten for å avdekke mening, følelser og bevisste mønstre som former opplevelsen din.',
  components_text1_card_2_title: 'Reflekter og integrer',
  components_text1_card_2_text: 'Fra emosjonelle blokkeringer til planetariske sykluser – disse guidene tilbyr verktøy for refleksjon, helbredelse og transformasjon gjennom mindful ritualer og astrologisk visdom.',
  components_text1_link: 'Se alle guider',
  components_footer_text: 'Finn klarhet, balanser sinnet ditt og få kontakt med mening – ditt sted for astrologi, meditasjon og kjærlighet.',
};